export const dlItemsViewListEvent = (props) => {
    const categoriesDL = window.dataLayer.filter(r => r.page_context !== undefined);
    const items = categoriesDL.length > 0
        ? categoriesDL[categoriesDL.length - 1].page_context?.items ?? []
        : [];
    window.dataLayer.push({
        page_context: {
            items: [
                ...items,
                ...props.map(({ name, type, path }) => ({
                    category_name: name,
                    category_type: type,
                    category_path: path ?? name
                }))
            ]
        }
    });
};
